import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import { toast } from "react-toastify";


export default function DeploymentSuccess() {
  const { fetchOrganisationDetails, fetchRequest } = useMyContext()
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [orgDetails, setOrgdetails] = useState(null);
  const baseAppApi = process.env.REACT_APP_Base_Webnexs_URL
  const baseURL = process.env.REACT_APP_Baseurl
  const DEPLOYMENT_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_ID

  const handleOrganisationDetails = async () => {
    try {
      const storedData = await fetchOrganisationDetails(DEPLOYMENT_ID);
      setOrgdetails(storedData?.data);
    } catch (error) {
      console.error("Error fetching organisation details:", error);
      return null;
    }
  };
  useEffect(() => {
    const fetchRequest = async () => {
      await handleOrganisationDetails();
    };
    fetchRequest();
  }, []);

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      try {
        const res = await axios.post(
          `${baseAppApi}/userapi/config_data`,
          {
            org_id: orgDetails?.deployment_org_id,
            deployment_id: orgDetails?.deployment_id,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const data = res.data?.deployment_data;
        setData(data);

        const cleanedData = {
          sitetitle: data?.sitetitle,
          package: data?.package,
          deployment_id: data?.deployment_id,
          deployment_user_id: data?.userid,
          deployment_token_id: data?.deployment_token_id,
          subscription_starts_at: data?.subscription_starts_at || data?.user_subscription_starts_at,
          subscription_ends_at: data?.subscription_ends_at || data?.user_subscription_ends_at,
        };

        try {
          const updateRes = await fetchRequest({
            method: "POST",
            url: `${baseURL}/admin/update-organisation-subscription`,
            data: {
              deployment_id: orgDetails?.deployment_id,
              org_id: orgDetails?.deployment_org_id,
              deployment_data: cleanedData,
            },
          });

          console.log("Update response:", updateRes);
        } catch (persistErr) {
          console.error("Failed to persist organisation subscription details:", persistErr);
        }
      } catch (e) {
        toast.error(e?.response?.data?.message || "Failed to load plans");
      } finally {
        setLoading(false);
      }
    };

    if (baseAppApi && orgDetails) fetchSubscriptionDetails();
  }, [baseAppApi, orgDetails]);

  if (loading) return <div className="container p-4"><div>Loading deployment result...</div></div>;
  if (error) return <div className="container p-4"><div className="alert alert-danger">{error}</div></div>;

  const d = data || {};

  return (
    <div className="container py-4">
      <h3 className="text-success fw-bold mb-4">Deployment Successful</h3>
      <p className="text-muted mb-4">Your configuration has been updated from BaseApp.</p>

      {/* Overview Card */}
      <div className="card mb-3 p-3 shadow-sm rounded-3">
        <h5 className="fw-bold border-bottom pb-2 mb-3">Overview</h5>
        <div className="row g-3">
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Site Title</div>
            <div className="fw-semibold">{d?.sitetitle || '-'}</div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Company</div>
            <div className="fw-semibold">{d?.company_name || '-'}</div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Package</div>
            <div className="fw-semibold text-capitalize">{d?.package || '-'}</div>
          </div>
        </div>
      </div>

      {/* Admin Card */}
      <div className="card mb-3 p-3 shadow-sm rounded-3">
        <h5 className="fw-bold border-bottom pb-2 mb-3">Admin</h5>
        <div className="row g-3">
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Admin Name</div>
            <div className="fw-semibold">{d?.admin_name || '-'}</div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Admin Email</div>
            <div className="fw-semibold">{d?.admin_email || '-'}</div>
          </div>
          <div className="col-md-12 mb-2">
            <div className="fw-bold">Admin URL</div>
            <a href={d?.admin_url} target="_blank" rel="noreferrer" className="fw-semibold text-decoration-underline">
              {d?.admin_url || '-'}
            </a>
          </div>
        </div>
      </div>

      {/* Subscription Card */}
      <div className="card mb-3 p-3 shadow-sm rounded-3">
        <h5 className="fw-bold border-bottom pb-2 mb-3">Subscription</h5>
        <div className="row g-3">
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Starts At</div>
            <div className="fw-semibold">{d?.user_subscription_starts_at ? new Date(d?.user_subscription_starts_at).toLocaleString() : '-'}</div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Ends At</div>
            <div className="fw-semibold text-danger">{d?.user_subscription_ends_at ? new Date(d?.user_subscription_ends_at).toLocaleString() : '-'}</div>
          </div>
        </div>
      </div>

      {/* Server Card */}
      <div className="card mb-3 p-3 shadow-sm rounded-3">
        <h5 className="fw-bold border-bottom pb-2 mb-3">Server</h5>
        <div className="row g-3">
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Host</div>
            <div className="fw-semibold">{d?.host || '-'}</div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="fw-bold">Port</div>
            <div className="fw-semibold">{d?.port || '-'}</div>
          </div>
          <div className="col-md-12 mb-2">
            <div className="fw-bold">Base URL</div>
            <a href={d?.baseurl} target="_blank" rel="noreferrer" className="fw-semibold text-decoration-underline">
              {d?.baseurl || '-'}
            </a>
          </div>
        </div>
      </div>
    </div>

  );
}
